/*
 * komi: interações das seções e blocos próprios. Sem biblioteca externa.
 * O HTML já sai com o conteúdo final; o JavaScript só liga o comportamento.
 *
 *  <komi-leve-mais>   leve 1, 2 ou 3 com desconto, ligado ao formulário de compra
 *  rodapé             no celular, as colunas viram sanfona fechada
 */

const moeda = (() => {
  const formato = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL',
  });
  // espaço inseparável entre o R$ e o número: o valor nunca quebra em duas linhas
  return (centavos) => formato.format(Math.round(centavos) / 100).replace(/\s/g, ' ');
})();

function definir(nome, classe) {
  if (!customElements.get(nome)) customElements.define(nome, classe);
}

/* ---------- Leve 1, 2 ou 3 ---------- */

class KomiLeveMais extends HTMLElement {
  connectedCallback() {
    this.secao = this.closest('.shopify-section') || document;
    try {
      this.variantes = JSON.parse(this.querySelector('script[data-variantes]')?.textContent || '[]');
    } catch {
      this.variantes = [];
    }
    this.modo = this.dataset.modo === 'pct' ? 'pct' : 'valor';
    this.pcts = { 1: 0, 2: Number(this.dataset.pct2) || 0, 3: Number(this.dataset.pct3) || 0 };
    this.vals = { 1: 0, 2: Number(this.dataset.val2) || 0, 3: Number(this.dataset.val3) || 0 };
    this.escolhido = Number(this.querySelector('input[type="radio"]:checked')?.value) || 1;
    // komi 2026: com 2 ou 3 pares, cada par a partir do segundo tem a sua variante
    this.paresAtivos = this.dataset.pares === 'true';

    // O envio do formulário passa aqui antes do Horizon: ele delega os eventos no document, em captura,
    // então a escuta fica no window, em captura, que roda antes
    this.aoEnviar = (evento) => {
      if (!this.paresAtivos || this.escolhido < 2 || this.liberado) return;
      const form = this.formulario()?.querySelector('form');
      if (!form || evento.target !== form || !this.secao.contains(form)) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      this.enviarPares(form);
    };
    window.addEventListener('submit', this.aoEnviar, true);

    // komi 24/10: com par sem cor ou número, o clique para aqui, antes da animação de ir à sacola do Horizon
    // (handleClick do botão), e só mostra o aviso; o botão da barra fixa tem animação própria e leva a mesma marca
    this.aoClicar = (evento) => {
      const botao = evento.target instanceof Element && evento.target.closest('[ref="addToCartButton"]');
      if (!botao || !botao.hasAttribute('data-komi-falta')) return;
      if (!this.secao.contains(botao) && !botao.closest('sticky-add-to-cart')) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      const form = this.formulario()?.querySelector('form');
      if (form) this.enviarPares(form);
    };
    window.addEventListener('click', this.aoClicar, true);

    // Escolher a variante de um par apaga o aviso
    this.aoSelect = (evento) => {
      if (!(evento.target instanceof HTMLSelectElement && this.contains(evento.target))) return;
      this.aviso('');
      this.travar();
    };
    this.addEventListener('change', this.aoSelect);

    // komi 25/10: o par 1 do cartão troca a variante no seletor de cima, como se a pessoa clicasse lá
    this.aoPar1 = (evento) => {
      const s = evento.target;
      if (!(s instanceof HTMLSelectElement) || !s.hasAttribute('data-par1-opcao') || !this.contains(s)) return;
      this.escolherNoSeletor(Number(s.dataset.par1Opcao), s.value);
    };
    this.addEventListener('change', this.aoPar1);

    this.aoMudar = (evento) => {
      const radio = evento.target.closest('input[type="radio"]');
      if (!radio || !this.contains(radio)) return;
      this.escolher(Number(radio.value));
    };
    this.addEventListener('change', this.aoMudar);

    // Quantidade mexida à mão (+ e -): o cartão acompanha
    this.aoQuantidade = (evento) => {
      if (this.aplicando || this.paresAtivos) return;
      const q = Number(evento.detail?.quantity) || Number(this.entrada()?.value) || 1;
      this.marcar(q);
    };
    this.secao.addEventListener('quantity-selector:update', this.aoQuantidade);

    // Troca de variante: recalcula os preços e devolve a quantidade escolhida
    this.aoVariante = (evento) => {
      if (evento.target instanceof Element && evento.target.closest('product-card')) return;
      const aplicar = (detail) => {
        const id = String(detail?.resource?.id ?? '');
        const v = this.variantes.find((x) => String(x.id) === id);
        if (v) this.variante = v;
        if (v) this.par1(v);
        // Depois do morph do formulário, que roda na mesma volta
        setTimeout(() => {
          this.precos();
          this.escolher(this.escolhido, false);
        }, 0);
      };
      if (evento.promise) evento.promise.then(({ detail }) => aplicar(detail)).catch(() => {});
      else aplicar(evento.detail);
    };
    this.secao.addEventListener('shopify:product:select', this.aoVariante);
    this.ouvirEventoPadrao();

    this.variante = this.variantes.find((x) => String(x.id) === this.dataset.variante) || this.variantes[0];
    this.precos();
    // Aplica a quantidade inicial depois que o formulário existir
    requestAnimationFrame(() => this.escolher(this.escolhido, false));
  }

  async ouvirEventoPadrao() {
    try {
      const { StandardEvents } = await import('@shopify/events');
      const nome = StandardEvents?.productSelect;
      if (nome && nome !== 'shopify:product:select') {
        this.nomeEvento = nome;
        this.secao.addEventListener(nome, this.aoVariante);
      }
    } catch {
      /* sem eventos padrão: os preços ficam os do carregamento */
    }
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.aoMudar);
    this.removeEventListener('change', this.aoSelect);
    this.removeEventListener('change', this.aoPar1);
    window.removeEventListener('submit', this.aoEnviar, true);
    window.removeEventListener('click', this.aoClicar, true);
    this.secao?.removeEventListener('quantity-selector:update', this.aoQuantidade);
    this.secao?.removeEventListener('shopify:product:select', this.aoVariante);
    if (this.nomeEvento) this.secao?.removeEventListener(this.nomeEvento, this.aoVariante);
  }

  formulario() {
    return this.secao.querySelector('product-form-component');
  }

  /** O seletor de cor e tamanho da página (não o de cards nem o da barra fixa). */
  seletor() {
    return [...this.secao.querySelectorAll('variant-picker')].find((v) => !v.closest('product-card, komi-leve-junto, sticky-add-to-cart'));
  }

  /** Marca no seletor de cima a opção i (0 = primeira) com o valor dado; o Horizon troca a variante. */
  escolherNoSeletor(i, valor) {
    const seletor = this.seletor();
    if (!seletor) return;
    const alvo = [...seletor.querySelectorAll('input[type="radio"][data-input-id], option[data-input-id]')].find(
      (el) => el.dataset.inputId.startsWith(`${i + 1}-`) && el.value === valor
    );
    if (alvo instanceof HTMLInputElement) {
      if (!alvo.checked) alvo.click();
    } else if (alvo instanceof HTMLOptionElement) {
      const select = alvo.closest('select');
      if (select && select.value !== valor) {
        select.value = valor;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  /** Põe nas listas do par 1 as opções da variante escolhida em cima. */
  par1(v) {
    if (!Array.isArray(v.options)) return;
    for (const s of this.querySelectorAll('select[data-par1-opcao]')) {
      const valor = v.options[Number(s.dataset.par1Opcao)];
      if (valor != null && s.value !== valor) s.value = valor;
    }
  }

  entrada() {
    return /** @type {HTMLInputElement|null} */ (this.formulario()?.querySelector('input[name="quantity"]'));
  }

  desconto(q, preco) {
    if (q < 2) return 0;
    if (this.modo === 'valor') return this.vals[q] || 0;
    // komi 25/10: corta o centavo como a Shopify (15% de R$ 359,70 dá R$ 53,95, não R$ 53,96)
    return Math.floor((preco * q * (this.pcts[q] || 0)) / 100);
  }

  precos() {
    const v = this.variante;
    if (!v) return;
    const preco = Number(v.price) || 0;
    const de = Number(v.compare_at_price) || 0;
    const base = de > preco ? de : preco;
    for (const cartao of this.querySelectorAll('[data-qtd]')) {
      const q = Number(cartao.dataset.qtd);
      const riscado = base * q;
      let total = preco * q - this.desconto(q, preco);
      if (total < 100) total = preco * q;
      const riscadoEl = cartao.querySelector('[data-riscado]');
      const totalEl = cartao.querySelector('[data-total]');
      const cadaEl = cartao.querySelector('[data-cada]');
      const economiaEl = cartao.querySelector('[data-economia]');
      if (totalEl) totalEl.textContent = moeda(total);
      if (riscadoEl) {
        riscadoEl.textContent = moeda(riscado);
        riscadoEl.closest('[data-riscado-linha]')?.toggleAttribute('hidden', riscado <= total);
      }
      if (cadaEl) cadaEl.textContent = moeda(Math.floor(total / q));
      if (economiaEl) {
        economiaEl.textContent = moeda(riscado - total);
        economiaEl.closest('[data-economia-linha]')?.toggleAttribute('hidden', riscado - total < 1);
      }
      // komi 23/10: pílula "% OFF" do cartão
      const pctEl = cartao.querySelector('[data-pct]');
      if (pctEl) {
        const pct = riscado > 0 ? Math.round(((riscado - total) / riscado) * 100) : 0;
        pctEl.textContent = String(pct);
        pctEl.closest('[data-pct-linha]')?.toggleAttribute('hidden', pct < 1);
      }
    }
    this.toggleAttribute('indisponivel', v.available === false);
    this.avisarResumo();
  }

  /** Total e riscado da quantidade escolhida, para o bloco komi · Leve junto. */
  resumo() {
    const v = this.variante;
    if (!v) return null;
    const preco = Number(v.price) || 0;
    const de = Number(v.compare_at_price) || 0;
    const base = de > preco ? de : preco;
    const q = this.escolhido || 1;
    let total = preco * q - this.desconto(q, preco);
    if (total < 100) total = preco * q;
    return { total, riscado: base * q };
  }

  avisarResumo() {
    this.dispatchEvent(new CustomEvent('komi:leve', { bubbles: true }));
  }

  marcar(q) {
    let achou = false;
    for (const radio of this.querySelectorAll('input[type="radio"]')) {
      const igual = Number(radio.value) === q;
      radio.checked = igual;
      if (igual) achou = true;
    }
    this.toggleAttribute('outra-quantidade', !achou);
    if (achou) this.escolhido = q;
    for (const painel of this.querySelectorAll('[data-pares-de]')) {
      painel.hidden = Number(painel.dataset.paresDe) !== this.escolhido;
    }
    this.aviso('');
    this.botao(achou ? q : null);
    // komi 23/10: "Selecione a quantidade: 2 pares"
    const nome = this.querySelector(`[data-qtd="${this.escolhido}"] .komi-leve__nome`);
    const escolhido = this.querySelector('[data-escolhido]');
    if (nome && escolhido) escolhido.textContent = nome.textContent.trim();
    this.avisarResumo();
  }

  escolher(q, avisar = true) {
    this.escolhido = q;
    this.marcar(q);
    const entrada = this.entrada();
    if (!entrada) return;
    this.aplicando = true;
    // No modo pares o formulário leva só o par 1; os outros entram antes, pela sacola
    entrada.value = this.paresAtivos && q > 1 ? '1' : String(q);
    const seletor = entrada.closest('quantity-selector-component');
    // @ts-ignore
    seletor?.updateButtonStates?.();
    // @ts-ignore
    if (seletor?.onQuantityChange) seletor.onQuantityChange();
    else if (avisar) entrada.dispatchEvent(new Event('change', { bubbles: true }));
    this.aplicando = false;
    this.botao(q);
  }

  /** Mostra (ou apaga) o aviso do painel aberto e leva o foco ao campo que falta. */
  aviso(texto, campo) {
    const painel = this.querySelector(`[data-pares-de="${this.escolhido}"]`);
    for (const el of this.querySelectorAll('[data-erro]')) {
      el.hidden = true;
      el.textContent = '';
    }
    for (const el of this.querySelectorAll('.komi-leve__select[aria-invalid]')) el.removeAttribute('aria-invalid');
    if (!texto || !painel) return;
    const erro = painel.querySelector('[data-erro]');
    if (erro) {
      erro.textContent = texto;
      erro.hidden = false;
    }
    if (campo) {
      campo.setAttribute('aria-invalid', 'true');
      campo.focus();
    }
  }

  /** Confere os pares 2 e 3, põe esses na sacola e deixa o Horizon enviar o par 1 e abrir a sacola. */
  async enviarPares(form) {
    const painel = this.querySelector(`[data-pares-de="${this.escolhido}"]`);
    if (!painel) return;
    const artigo = (nome) => {
      if (/^cor/.test(nome)) return 'a cor';
      if (/^(tamanho|n[uú]mero|numera)/.test(nome)) return 'o número';
      return `a opção "${nome}"`;
    };
    const itens = [];
    for (const par of painel.querySelectorAll('[data-par]')) {
      const n = par.dataset.par;
      const selects = [...par.querySelectorAll('select')];
      const vazio = selects.find((s) => !s.value);
      if (vazio) {
        this.aviso(this.dataset.textoFalta.replace('[opcao]', artigo(vazio.dataset.nome || '')).replace('[n]', n), vazio);
        return;
      }
      const valores = selects.map((s) => s.value);
      const v = this.variantes.find(
        (x) => Array.isArray(x.options) && x.options.length === valores.length && x.options.every((o, i) => o === valores[i])
      );
      if (!v || v.available === false) {
        this.aviso(this.dataset.textoEsgotado.replace('[n]', n), selects[0]);
        return;
      }
      const mesmo = itens.find((i) => i.id === v.id);
      if (mesmo) mesmo.quantity += 1;
      else itens.push({ id: v.id, quantity: 1 });
    }
    this.aviso('');
    // komi 23/10: os itens marcados no komi · Leve junto vão no mesmo envio
    const junto = this.secao.querySelector('komi-leve-junto');
    if (junto && typeof junto.itens === 'function') itens.push(...junto.itens());
    if (await this.enviarJunto(form, itens)) return;
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const resposta = await fetch(`${raiz}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: itens }),
      });
      if (!resposta.ok) {
        const dados = await resposta.json().catch(() => ({}));
        this.aviso(dados.description || dados.message || 'Não deu para adicionar os pares. Tente de novo.');
        return;
      }
    } catch {
      this.aviso('Sem conexão. Tente de novo.');
      return;
    }
    const entrada = this.entrada();
    if (entrada) entrada.value = '1';
    this.liberado = true;
    if (junto) junto.incluido = true;
    try {
      form.requestSubmit();
    } finally {
      this.liberado = false;
      if (junto) junto.incluido = false;
    }
  }

  /**
   * komi 26/10: o par 1, os outros pares e o Leve junto vão numa ida só à sacola, que já devolve o desenho da
   * gaveta; a gaveta é avisada pelo mesmo evento que o formulário do Horizon manda. Antes eram três idas em fila
   * (pares 2 e 3, o par 1 e o /cart.json que o Horizon lê antes de avisar), e a gaveta só abria no fim, perto de
   * 2,4 s. Devolve false quando não dá para ir por aqui (módulo de eventos fora do ar), e o caminho antigo segue.
   */
  async enviarJunto(form, itens) {
    let Evento;
    try {
      ({ CartLinesUpdateEvent: Evento } = await import('@shopify/events'));
    } catch {
      return false;
    }
    if (!Evento || typeof Evento.createPromise !== 'function') return false;
    const dados = new FormData(form);
    const id = Number(dados.get('id'));
    if (!id) return false;
    const primeiro = { id, quantity: 1 };
    const propriedades = {};
    for (const [chave, valor] of dados) {
      const m = /^properties\[(.+)\]$/.exec(chave);
      if (m && valor !== '') propriedades[m[1]] = valor;
    }
    if (Object.keys(propriedades).length) primeiro.properties = propriedades;
    const todos = [primeiro, ...itens];
    const secoes = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const icone = document.querySelector('cart-icon');
    const antes = Number(icone?.currentCartCount) || 0;
    const somados = todos.reduce((soma, item) => soma + item.quantity, 0);
    const falhou = (texto) => {
      this.aviso(texto);
      return true;
    };
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const renderizador = import('@theme/section-renderer').catch(() => null);
    let resposta;
    try {
      const r = await fetch(`${raiz}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: todos, sections: secoes.join(','), sections_url: window.location.pathname }),
      });
      resposta = await r.json().catch(() => ({}));
      if (!r.ok) return falhou(resposta.description || resposta.message || 'Não deu para adicionar os pares. Tente de novo.');
    } catch {
      return falhou('Sem conexão. Tente de novo.');
    }
    // komi 26/10, tarde: com a sacola vazia, o Horizon abria a gaveta vazia e só depois a preenchia, por uma
    // transição de tela que espera um quadro de desenho, e o produto aparecia por último. Aqui a gaveta já sai
    // preenchida antes de abrir; o Horizon, ao receber o aviso, encontra o mesmo conteúdo e não anima nada.
    const modulo = await renderizador;
    if (modulo && typeof modulo.morphSection === 'function' && resposta.sections) {
      for (const comp of document.querySelectorAll('cart-items-component')) {
        const desenho = resposta.sections[comp.dataset.sectionId];
        if (!desenho) continue;
        const gaveta = comp.dataset.drawer !== undefined;
        const vazia = gaveta && comp.querySelector('[data-cart-drawer-empty]') !== null;
        try {
          modulo.morphSection(comp.dataset.sectionId, desenho, { mode: gaveta ? 'hydration' : 'full', injectStylesheet: vazia });
        } catch {
          // sem o desenho na página, o Horizon preenche como antes
        }
      }
    }
    // o total de pares vem do desenho da gaveta, como o Horizon faz; sem ele, a conta de antes mais os novos
    const html = resposta.sections && resposta.sections[secoes[0]];
    const lido = html ? Number(new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]')?.textContent) : NaN;
    const fotos = [...document.querySelectorAll('cart-items-component[data-drawer] img')].filter((foto) => !foto.complete);
    if (fotos.length) {
      fotos.forEach((foto) => (foto.loading = 'eager'));
      await Promise.race([
        Promise.all(fotos.map((foto) => foto.decode().catch(() => {}))),
        new Promise((pronto) => setTimeout(pronto, 1000)),
      ]);
    }
    // o aviso sai só agora, com a gaveta já preenchida e com as fotos: ela abre uma vez, com tudo dentro
    const adiado = Evento.createPromise();
    this.dispatchEvent(
      new Evento({
        action: 'add',
        context: 'product',
        lines: todos.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
        promise: adiado.promise,
      })
    );
    adiado.resolve({
      detail: {
        items: resposta.items,
        sections: resposta.sections,
        itemCount: Number.isFinite(lido) ? lido : antes + somados,
        source: 'komi-leve-mais',
        didError: false,
      },
    });
    this.aviso('');
    return true;
  }

  /** komi 24/10: com 2 ou 3 pares, o botão fica apagado até cada par ter cor e número; o clique ainda leva ao campo que falta. */
  travar() {
    const botao = this.formulario()?.querySelector('[ref="addToCartButton"]');
    if (!botao) return;
    const painel = this.paresAtivos && this.escolhido > 1 ? this.querySelector(`[data-pares-de="${this.escolhido}"]`) : null;
    const falta = !!painel && [...painel.querySelectorAll('select')].some((s) => !s.value);
    for (const b of [botao, document.querySelector('sticky-add-to-cart [ref="addToCartButton"]')]) {
      if (!b) continue;
      if (falta) {
        b.setAttribute('data-komi-falta', '');
        b.setAttribute('aria-disabled', 'true');
      } else if (b.hasAttribute('data-komi-falta')) {
        b.removeAttribute('data-komi-falta');
        b.removeAttribute('aria-disabled');
      }
    }
  }

  /** Muda o texto do botão de compra para dizer a quantidade escolhida. */
  botao(q) {
    this.travar();
    const botao = this.formulario()?.querySelector('[ref="addToCartButton"]');
    if (!botao) return;
    const texto = [...botao.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
    if (!texto) return;
    const atual = texto.textContent.trim();
    // Guarda o texto que veio do servidor (muda com a variante: comprar, esgotado)
    if (!botao.dataset.komiVarios || atual !== botao.dataset.komiVarios) botao.dataset.komiTextoOriginal = atual;
    const original = botao.dataset.komiTextoOriginal || atual;
    const podeComprar = !botao.disabled && original === this.dataset.textoComprar;
    if (!podeComprar || !q || q < 2) {
      texto.textContent = original;
      return;
    }
    const novo = this.dataset.textoVarios.replace('[q]', String(q));
    botao.dataset.komiVarios = novo;
    texto.textContent = novo;
  }
}
definir('komi-leve-mais', KomiLeveMais);

/* ---------- Rodapé em sanfona no celular ---------- */

function rodapeSanfona() {
  const celular = window.matchMedia('(max-width: 749px)');
  const ajustar = () => {
    for (const coluna of document.querySelectorAll('.komi-rodape__coluna')) {
      if (celular.matches) coluna.removeAttribute('open');
      else coluna.setAttribute('open', '');
    }
  };
  ajustar();
  celular.addEventListener('change', ajustar);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rodapeSanfona);
else rodapeSanfona();

/* ---------- Vantagens em carrossel no celular: o ponto acompanha o cartão (23/10/2026) ---------- */

function vantagensPontos() {
  for (const lista of document.querySelectorAll('.komi-vantagens')) {
    const pontos = lista.parentElement?.querySelector('.komi-vantagens__pontos');
    if (!pontos || lista.dataset.komiPontos) continue;
    lista.dataset.komiPontos = '1';
    const marcar = () => {
      const itens = [...lista.children];
      if (!itens.length) return;
      const passo = itens.length > 1 ? itens[1].offsetLeft - itens[0].offsetLeft : lista.clientWidth;
      const fim = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
      const atual = fim ? itens.length - 1 : Math.round(lista.scrollLeft / (passo || 1));
      [...pontos.children].forEach((p, i) => p.classList.toggle('is-ativo', i === atual));
    };
    lista.addEventListener('scroll', marcar, { passive: true });
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vantagensPontos);
else vantagensPontos();

/* ---------- Leve junto: itens extras marcados, total, parcelas e economia (23/10/2026) ---------- */

class KomiLeveJunto extends HTMLElement {
  connectedCallback() {
    this.secao = this.closest('.shopify-section') || document;
    this.aoMudar = () => this.calcular();
    this.addEventListener('change', this.aoMudar);
    this.secao.addEventListener('komi:leve', this.aoMudar);

    // Mesmo gancho do Leve: o envio passa aqui antes do Horizon e os itens marcados entram primeiro.
    // Com 2 ou 3 pares em escolha, quem envia é o Leve, que já leva estes itens junto.
    this.aoEnviar = (evento) => {
      if (this.liberado || this.incluido) return;
      const itens = this.itens();
      if (!itens.length) return;
      const form = this.secao.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      if (!form || evento.target !== form) return;
      const leve = this.secao.querySelector('komi-leve-mais');
      if (leve && leve.paresAtivos && leve.escolhido > 1 && !leve.liberado) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      this.enviar(form, itens);
    };
    window.addEventListener('submit', this.aoEnviar, true);
    this.calcular();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.aoMudar);
    this.secao?.removeEventListener('komi:leve', this.aoMudar);
    window.removeEventListener('submit', this.aoEnviar, true);
  }

  /** Itens marcados, no formato do /cart/add.js. */
  itens() {
    return [...this.querySelectorAll('.komi-junto__check:checked')].map((c) => ({ id: Number(c.value), quantity: 1 }));
  }

  calcular() {
    const preco = Number(this.dataset.preco) || 0;
    const base = this.secao.querySelector('komi-leve-mais')?.resumo?.() || {
      total: preco,
      riscado: Math.max(preco, Number(this.dataset.de) || 0),
    };
    let total = base.total;
    let riscado = base.riscado;
    for (const c of this.querySelectorAll('.komi-junto__check:checked')) {
      const p = Number(c.dataset.preco) || 0;
      total += p;
      riscado += Math.max(p, Number(c.dataset.de) || 0);
    }
    const totalEl = this.querySelector('[data-junto-total]');
    if (totalEl) totalEl.textContent = moeda(total);
    const riscadoEl = this.querySelector('[data-junto-riscado]');
    if (riscadoEl) {
      riscadoEl.textContent = moeda(riscado);
      riscadoEl.hidden = riscado <= total;
    }
    const n = Math.max(1, Number(this.dataset.parcelas) || 1);
    const parcelasEl = this.querySelector('[data-junto-parcelas]');
    if (parcelasEl) {
      parcelasEl.textContent = (this.dataset.textoParcelas || '')
        .replace('[n]', String(n))
        .replace('[valor]', moeda(Math.ceil(total / n)));
    }
    const economia = riscado - total;
    const economiaEl = this.querySelector('[data-junto-economia]');
    if (economiaEl) {
      const pct = riscado > 0 ? Math.round((economia / riscado) * 100) : 0;
      economiaEl.textContent = (this.dataset.textoEconomia || '').replace('[valor]', moeda(economia)).replace('[pct]', String(pct));
      economiaEl.hidden = economia < 1;
    }
    for (const c of this.querySelectorAll('.komi-junto__check')) c.closest('.komi-junto__item')?.toggleAttribute('marcado', c.checked);
  }

  async enviar(form, itens) {
    const erro = this.querySelector('[data-junto-erro]');
    if (erro) erro.hidden = true;
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const resposta = await fetch(`${raiz}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: itens }),
      });
      if (!resposta.ok) {
        const dados = await resposta.json().catch(() => ({}));
        throw new Error(dados.description || dados.message || '');
      }
    } catch (e) {
      if (erro) {
        erro.textContent = (e && e.message) || 'Não deu para adicionar os itens marcados. Tente de novo.';
        erro.hidden = false;
      }
      return;
    }
    this.liberado = true;
    try {
      form.requestSubmit();
    } finally {
      this.liberado = false;
    }
  }
}
definir('komi-leve-junto', KomiLeveJunto);

/* ---------- Barra fixa de compra: "Trocar" volta à escolha de cor e número (23/10/2026) ---------- */

document.addEventListener('click', (evento) => {
  const botao = evento.target instanceof Element ? evento.target.closest('[data-komi-trocar]') : null;
  if (!botao) return;
  const alvo = document.querySelector('.product-details variant-picker, .product-details .variant-picker');
  if (!alvo) return;
  const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  alvo.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'center' });
});

/* ---------- Avaliações em carrossel: um ponto por cartão, que acompanha a rolagem (25/10/2026) ---------- */

function avaliacoesPontos() {
  for (const lista of document.querySelectorAll('.komi-avaliacoes__lista')) {
    const pontos = lista.parentElement?.querySelector('.komi-avaliacoes__pontos');
    if (!pontos || lista.dataset.komiPontos) continue;
    lista.dataset.komiPontos = '1';
    const cartoes = [...lista.children].filter((c) => c.classList.contains('komi-avaliacao'));
    if (cartoes.length < 2) continue;
    pontos.replaceChildren(
      ...cartoes.map((cartao) => {
        const ponto = document.createElement('span');
        ponto.className = 'komi-avaliacoes__ponto';
        ponto.addEventListener('click', () => lista.scrollTo({ left: cartao.offsetLeft - lista.offsetLeft, behavior: 'smooth' }));
        return ponto;
      })
    );
    const marcar = () => {
      const fim = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
      let atual = 0;
      cartoes.forEach((c, i) => {
        if (c.offsetLeft - lista.offsetLeft <= lista.scrollLeft + 8) atual = i;
      });
      if (fim) atual = cartoes.length - 1;
      [...pontos.children].forEach((p, i) => p.classList.toggle('is-ativo', i === atual));
    };
    lista.addEventListener('scroll', marcar, { passive: true });
    marcar();
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avaliacoesPontos);
else avaliacoesPontos();
// no editor do tema o bloco é redesenhado a cada mudança
document.addEventListener('shopify:section:load', avaliacoesPontos);
document.addEventListener('shopify:block:select', avaliacoesPontos);

/* ---------- Frete e prazo: endereço pelo CEP, data prevista e meta de frete grátis (25/10/2026) ---------- */

const KOMI_REGIOES = {
  sudeste: ['SP', 'RJ', 'MG', 'ES'],
  sul: ['PR', 'SC', 'RS'],
  'centro-oeste': ['DF', 'GO', 'MT', 'MS'],
  nordeste: ['BA', 'SE', 'AL', 'PE', 'PB', 'RN', 'CE', 'PI', 'MA'],
  norte: ['AM', 'PA', 'AC', 'RO', 'RR', 'AP', 'TO'],
};

const KOMI_RAIO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>';
const KOMI_CAMINHAO =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';

/* komi 25/10: CEP lembrado no navegador e levado à sacola (atributo _komi_cep, que o checkout da Marcha lê no /cart.js) */
const KOMI_CEP = 'komi_cep';
const KOMI_CEP_ENDERECOS = new Map(); // ViaCEP já consultado nesta página

function komiCepSalvo() {
  try {
    return (localStorage.getItem(KOMI_CEP) || '').replace(/\D/g, '').slice(0, 8);
  } catch {
    return '';
  }
}

/** Grava o CEP na sacola uma vez por sacola (o cookie cart muda quando a sacola é nova). */
async function komiCepNaSacola(cep) {
  const sacola = (document.cookie.match(/(?:^|; )cart=([^;]*)/) || [])[1];
  if (!cep || !sacola) return;
  const marca = `${cep}|${sacola}`;
  try {
    if (sessionStorage.getItem('komi_cep_sacola') === marca) return;
  } catch {}
  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const r = await fetch(`${raiz}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { _komi_cep: cep } }),
  });
  if (!r.ok) return;
  try {
    sessionStorage.setItem('komi_cep_sacola', marca);
  } catch {}
}

document.addEventListener('cart:update', () => setTimeout(() => komiCepNaSacola(komiCepSalvo()).catch(() => {}), 300));
komiCepNaSacola(komiCepSalvo()).catch(() => {});

class KomiFrete extends HTMLElement {
  // lidos na hora: a sacola lateral troca o campo e o resultado quando redesenha
  get campo() {
    return this.querySelector('[data-cep]');
  }

  get saida() {
    return this.querySelector('[data-resultado]');
  }

  connectedCallback() {
    if (this.ligado) return;
    this.ligado = true;
    try {
      this.prazos = JSON.parse(this.dataset.prazos || '{}');
    } catch {
      this.prazos = {};
    }
    try {
      this.opcoes = JSON.parse(this.dataset.opcoes || '[]');
    } catch {
      this.opcoes = [];
    }
    // máscara 00000-000, só números (ouvido no elemento, que fica, e não no campo, que a sacola troca)
    this.addEventListener('input', (evento) => {
      if (evento.target !== this.campo) return;
      const n = this.campo.value.replace(/\D/g, '').slice(0, 8);
      this.campo.value = n.length > 5 ? `${n.slice(0, 5)}-${n.slice(5)}` : n;
      this.campo.removeAttribute('aria-invalid');
      // komi 25/10: CEP completo calcula sozinho, sem clicar (o mesmo CEP não consulta de novo)
      if (n.length === 8 && n !== this.ultimoCep) this.calcular();
    });
    this.addEventListener('submit', (evento) => {
      evento.preventDefault();
      this.calcular();
    });
    // a barra do frete grátis acompanha a quantidade do Leve e a sacola
    this.refazer = () => {
      if (this.endereco) this.desenhar(this.endereco);
    };
    document.addEventListener('komi:leve', this.refazer);
    document.addEventListener('cart:update', this.refazer);
    // outro cálculo da página (produto ou sacola) com outro CEP: este acompanha
    this.aoCep = (evento) => {
      if (evento.detail === this.ultimoCep || !this.campo) return;
      this.campo.value = `${evento.detail.slice(0, 5)}-${evento.detail.slice(5)}`;
      this.calcular();
    };
    document.addEventListener('komi:cep', this.aoCep);
    this.lembrar();
    // a sacola lateral redesenha o conteúdo a cada mudança e volta o campo vazio: preenche de novo (endereço já em cache)
    this.vigia = new MutationObserver(() => this.lembrar());
    this.vigia.observe(this, { childList: true, subtree: true });
  }

  lembrar() {
    const salvo = komiCepSalvo();
    if (salvo.length !== 8 || !this.campo || this.campo.value) return;
    this.campo.value = `${salvo.slice(0, 5)}-${salvo.slice(5)}`;
    this.calcular();
  }

  disconnectedCallback() {
    document.removeEventListener('komi:leve', this.refazer);
    document.removeEventListener('cart:update', this.refazer);
    document.removeEventListener('komi:cep', this.aoCep);
  }

  mostrar(html, erro = false) {
    this.saida.hidden = false;
    this.saida.classList.toggle('komi-frete__resultado--erro', erro);
    this.saida.innerHTML = html;
  }

  async calcular() {
    const cep = (this.campo?.value || '').replace(/\D/g, '');
    if (cep.length !== 8) {
      this.campo?.setAttribute('aria-invalid', 'true');
      this.campo?.focus();
      this.mostrar('Digite os 8 números do CEP.', true);
      return;
    }
    this.ultimoCep = cep;
    if (KOMI_CEP_ENDERECOS.has(cep)) {
      this.endereco = KOMI_CEP_ENDERECOS.get(cep);
      await this.desenhar(this.endereco);
      return;
    }
    this.mostrar('Consultando…');
    const ctl = typeof AbortController === 'function' ? new AbortController() : null;
    const tempo = setTimeout(() => ctl?.abort(), 6000);
    try {
      const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal: ctl?.signal, credentials: 'omit' });
      const d = await r.json();
      if (!r.ok || d.erro) {
        this.endereco = null;
        this.mostrar('CEP não encontrado. Confira os números.', true);
        return;
      }
      this.endereco = d;
      KOMI_CEP_ENDERECOS.set(cep, d);
      await this.desenhar(d);
      try {
        localStorage.setItem(KOMI_CEP, cep);
      } catch {}
      document.dispatchEvent(new CustomEvent('komi:cep', { detail: cep }));
      komiCepNaSacola(cep).catch(() => {});
    } catch {
      this.ultimoCep = null; // falha de rede: o mesmo CEP pode tentar de novo
      this.mostrar('Não deu para consultar agora. Tente de novo.', true);
    } finally {
      clearTimeout(tempo);
    }
  }

  /** "14,90", "R$ 199" ou "199.00" em centavos; vazio ou inválido = null. */
  static centavos(texto) {
    let t = String(texto || '').replace(/[^\d,.]/g, '');
    if (!t) return null;
    if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
    const n = Math.round(parseFloat(t) * 100);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  /** Sacola + o que está escolhido na página (Leve ou preço da variante), em centavos. */
  async pedido() {
    let sacola = 0;
    try {
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      sacola = (await (await fetch(`${raiz}cart.js`, { headers: { Accept: 'application/json' } })).json()).total_price || 0;
    } catch {
      /* sem sacola: conta só a página */
    }
    const secao = this.closest('.shopify-section') || document;
    const leve = secao.querySelector('komi-leve-mais');
    const escolha = leve && typeof leve.resumo === 'function' ? leve.resumo()?.total || 0 : 0;
    return sacola + escolha;
  }

  /** Data de chegada: sai hoje até a hora de corte em dia útil, senão no próximo dia útil; soma o prazo de postagem
   * em dias corridos (25/10/2026, o da política de frete; a postagem cai em dia útil) e depois os dias úteis da transportadora. */
  previsao(dias, curta = false) {
    const partes = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date())
        .map((p) => [p.type, p.value])
    );
    // meio-dia em UTC: a conta de dias não sofre com fuso nem horário de verão
    const d = new Date(Date.UTC(+partes.year, +partes.month - 1, +partes.day, 12));
    const util = (x) => x.getUTCDay() > 0 && x.getUTCDay() < 6;
    const proximo = (x) => {
      do x.setUTCDate(x.getUTCDate() + 1);
      while (!util(x));
    };
    const corte = Number(this.dataset.horaCorte);
    if (!util(d) || (Number.isFinite(corte) && +partes.hour >= corte)) proximo(d);
    const postagem = Math.max(0, Number(this.dataset.postagem) || 0);
    if (postagem) {
      d.setUTCDate(d.getUTCDate() + postagem);
      while (!util(d)) d.setUTCDate(d.getUTCDate() + 1);
    }
    for (let i = 0; i < dias; i++) proximo(d);
    if (curta) {
      // "qua, 11/11", para a linha recolhida do frete na sacola
      const dia = new Intl.DateTimeFormat('pt-BR', { weekday: 'short', timeZone: 'UTC' }).format(d).replace('.', '');
      return `${dia}, ${new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' }).format(d)}`;
    }
    return new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d).replace('-feira', '');
  }

  async desenhar(d) {
    const esc = (t) => String(t || '').replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
    const ds = this.dataset;
    const html = [];
    // endereço: rua em negrito · bairro, cidade – UF
    const lugar = [d.bairro, d.localidade].filter(Boolean).map(esc).join(', ') + (d.uf ? ` – ${esc(d.uf)}` : '');
    html.push(`<p class="komi-frete__endereco">${d.logradouro ? `<strong>${esc(d.logradouro)}</strong> · ` : ''}${lugar}</p>`);

    // komi 25/10: opções de frete (ex.: Grátis sem seguro e Expresso com seguro), cada uma com valor e data
    if (this.opcoes.length) {
      let comData = false;
      for (const o of this.opcoes) {
        const valorOpcao = KomiFrete.centavos(o.valor);
        // na lista de opções o nome já diz "Frete": a pílula fica curta
        const preco = valorOpcao ? moeda(valorOpcao) : 'Grátis';
        const dias = (String(o.prazo || '').match(/\d+/g) || []).map(Number);
        const icone = o.icone === 'raio' ? KOMI_RAIO : KOMI_CAMINHAO;
        let linha =
          `<div class="komi-frete__opcao"><div class="komi-frete__envio"><span class="komi-frete__envio-nome"><span class="komi-frete__raio" aria-hidden="true">${icone}</span>` +
          `<span>${esc(o.nome)}${o.detalhe ? `<small class="komi-frete__detalhe">${esc(o.detalhe)}</small>` : ''}</span></span>` +
          `<span class="komi-frete__preco${valorOpcao ? '' : ' komi-frete__preco--gratis'}">${preco}</span></div>`;
        if (dias.length) {
          comData = true;
          linha += `<p class="komi-frete__data">Chega até ${esc(this.previsao(Math.max(...dias)))}</p>`;
        }
        if (o.prazo) linha += `<p class="komi-frete__antes">${esc(o.prazo)}${dias.length && ds.textoAntes ? ` · ${esc(ds.textoAntes)}` : ''}</p>`;
        html.push(linha + '</div>');
      }
      if (comData && ds.textoEnvio) html.push(this.envioHtml(esc));
      this.mostrar(html.join(''));
      // komi 25/10/2026: na sacola, a linha recolhida do frete mostra a primeira opção (valor e data)
      const resumo = this.closest('.komi-frete-resumo')?.querySelector('[data-resumo]');
      if (resumo) {
        const o = this.opcoes[0];
        const valor = KomiFrete.centavos(o.valor);
        const dias = (String(o.prazo || '').match(/\d+/g) || []).map(Number);
        resumo.textContent = `${valor ? moeda(valor) : 'Grátis'}${dias.length ? ` · até ${this.previsao(Math.max(...dias), true)}` : ''}`;
      }
      return;
    }

    const valor = KomiFrete.centavos(ds.valorFrete);
    const meta = KomiFrete.centavos(ds.gratisAcima);
    const total = valor && meta ? await this.pedido() : 0;
    const gratis = !valor || !meta || total >= meta;
    const preco = gratis ? esc(ds.textoFrete || 'Frete grátis') : `Frete ${moeda(valor)}`;
    html.push(
      `<div class="komi-frete__envio"><span class="komi-frete__envio-nome"><span class="komi-frete__raio" aria-hidden="true">` +
        `${KOMI_RAIO}</span>` +
        `${esc(ds.transportadora || 'Entrega')}</span><span class="komi-frete__preco${gratis ? ' komi-frete__preco--gratis' : ''}">${preco}</span></div>`
    );

    const regiao = Object.keys(KOMI_REGIOES).find((k) => KOMI_REGIOES[k].includes(d.uf));
    const prazo = regiao ? String(this.prazos[regiao] || '') : '';
    const dias = (prazo.match(/\d+/g) || []).map(Number);
    if (dias.length) {
      html.push(`<p class="komi-frete__data">Chega até ${esc(this.previsao(Math.max(...dias)))}</p>`);
      if (ds.textoAntes) html.push(`<p class="komi-frete__antes">${esc(ds.textoAntes)}</p>`);
    } else if (prazo) {
      html.push(`<p class="komi-frete__data">Prazo: ${esc(prazo)}</p>`);
    }

    if (!gratis) {
      const falta = meta - total;
      const pct = Math.max(4, Math.min(100, Math.round((total / meta) * 100)));
      const texto = esc(ds.textoFalta || 'Faltam [valor] para o frete sair grátis').replace('[valor]', `<strong>${moeda(falta)}</strong>`);
      html.push(`<div class="komi-frete__barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${pct}"><span style="width:${pct}%"></span></div>`);
      html.push(`<p class="komi-frete__falta">${texto}</p>`);
    }

    if (dias.length && ds.textoEnvio) html.push(this.envioHtml(esc));
    this.mostrar(html.join(''));
  }

  envioHtml(esc) {
    const corte = `${Number(this.dataset.horaCorte) || 0}h`;
    return `<p class="komi-frete__envio-texto">${esc(this.dataset.textoEnvio).replace('[hora]h', `<strong>${corte}</strong>`).replace('[hora]', `<strong>${corte}</strong>`)}</p>`;
  }
}
definir('komi-frete', KomiFrete);

/* ---------- Comparação no celular: botões trocam a alternativa mostrada ao lado da komi (25/10/2026) ---------- */

document.addEventListener('click', (evento) => {
  const botao = evento.target instanceof Element ? evento.target.closest('[data-komi-comp-ver]') : null;
  if (!botao) return;
  const comp = botao.closest('.komi-comp');
  comp.dataset.ver = botao.dataset.komiCompVer;
  comp.querySelectorAll('[data-komi-comp-ver]').forEach((b) => b.setAttribute('aria-pressed', String(b === botao)));
});

/* ---------- Descrição no computador mais alta que a tela: rola até o fim antes de ficar presa (25/10/2026) ---------- */

function descricaoSobra() {
  const descricao = document.querySelector('.product-information__media .komi-descricao--computador');
  if (!descricao) return;
  const ajustar = () => {
    const cabecalho = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    descricao.style.setProperty('--komi-desc-sobra', `${Math.min(0, window.innerHeight - descricao.offsetHeight - 48 - cabecalho)}px`);
  };
  ajustar();
  new ResizeObserver(ajustar).observe(descricao);
  window.addEventListener('resize', ajustar);
}
descricaoSobra();

/* ---------- Janela aberta no celular: a página de trás não rola (26/10/2026) ---------- */
// O Horizon marca o <html> com scroll-lock e esconde a rolagem; no toque do Safari do iPhone isso não basta, e o
// arrasto passa para a página de trás. Enquanto a marca existe, o arrasto vertical só vale dentro de uma área que
// ainda tem para onde rolar naquele sentido (a lista da sacola, por exemplo); o resto é barrado. A posição da página
// não muda, então o theme-drawer continua devolvendo o comprador ao mesmo ponto quando a janela fecha.
function travaDoCelular() {
  const html = document.documentElement;
  let x0 = 0;
  let y0 = 0;
  const podeRolar = (alvo, dy) => {
    for (let el = alvo instanceof Element ? alvo : null; el && el !== document.body; el = el.parentElement) {
      if (!/(auto|scroll)/.test(getComputedStyle(el).overflowY) || el.scrollHeight <= el.clientHeight + 1) continue;
      if (dy > 0 && el.scrollTop > 0) return true;
      if (dy < 0 && el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
    }
    return false;
  };
  document.addEventListener('touchstart', (ev) => {
    x0 = ev.touches[0]?.clientX ?? 0;
    y0 = ev.touches[0]?.clientY ?? 0;
  }, { passive: true });
  document.addEventListener('touchmove', (ev) => {
    if (!html.hasAttribute('scroll-lock') || ev.touches.length !== 1) return;
    const dx = ev.touches[0].clientX - x0;
    const dy = ev.touches[0].clientY - y0;
    x0 = ev.touches[0].clientX;
    y0 = ev.touches[0].clientY;
    if (Math.abs(dx) > Math.abs(dy)) return; // arrasto de lado (carrossel) fica livre
    if (!podeRolar(ev.target, dy) && ev.cancelable) ev.preventDefault();
  }, { passive: false });
}
travaDoCelular();

/* ---------- Título do card: até duas linhas, o resto some aos poucos (26/10/2026) ---------- */
// O komi-2026.css corta o título do card em duas linhas. Aqui só se marca o título que passou delas
// (data-komi-corta), para o fim sumir aos poucos nesses e não num título curto. Mede de novo quando o card muda
// de largura, quando a fonte termina de carregar e quando chegam cards novos (filtro, página seguinte).
function tituloDoCard() {
  const SELETOR = "a[ref='productTitleLink'] .text-block p, .komi-card__nome";
  const medir = (p) => p.toggleAttribute('data-komi-corta', p.scrollHeight > p.clientHeight + 1);
  const vigia = new ResizeObserver((itens) => itens.forEach((item) => medir(item.target)));
  const olhar = (raiz) => raiz.querySelectorAll(SELETOR).forEach((p) => vigia.observe(p));
  olhar(document);
  document.fonts?.ready.then(() => document.querySelectorAll(SELETOR).forEach(medir));
  new MutationObserver((mudancas) => {
    for (const mudanca of mudancas) {
      for (const no of mudanca.addedNodes) {
        if (!(no instanceof Element)) continue;
        if (no.matches(SELETOR)) vigia.observe(no);
        olhar(no);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tituloDoCard);
else tituloDoCard();
